export default {
  // Datos del usuario
  userData: (state) => {
    return { ...state.user }
  }
}
